export default [
  {
    link: 'https://местопамяти.рф/',
    src: '/imgs/banners/mp-ad.jpg',
    text: '',
    outerLink: true,
  },
  {
    link: 'https://lc.rt.ru/victorydictation',
    src: '/imgs/banners/win-ad.png',
    text: 'Смотреть курс',
    outerLink: true,
  },
];
